export const ADD_EXTRA='ADD_EXTRA'
export const ADD_EXTRA_SUCCESS= 'ADD_EXTRA_SUCCESS'
export const ADD_EXTRA_ERROR= 'ADD_EXTRA_ERROR'

export const CHANGE_EXTRAS_VISIBILITY='CHANGE_EXTRAS_VISIBILITY'
export const CHANGE_EXTRAS_VISIBILITY_SUCCESS= 'CHANGE_EXTRAS_VISIBILITY_SUCCESS'
export const CHANGE_EXTRAS_VISIBILITY_ERROR= 'CHANGE_EXTRAS_VISIBILITY_ERROR'

export const DELETE_EXTRA='DELETE_EXTRA'
export const DELETE_EXTRA_SUCCESS= 'DELETE_EXTRA_SUCCESS'
export const DELETE_EXTRA_ERROR= 'DELETE_EXTRA_ERROR'

export const DELETE_EXTRAS='DELETE_EXTRAS'
export const DELETE_EXTRAS_SUCCESS= 'DELETE_EXTRAS_SUCCESS'
export const DELETE_EXTRAS_ERROR= 'DELETE_EXTRAS_ERROR'

export const GET_EXTRA= 'GET_EXTRA'
export const GET_EXTRA_SUCCESS= 'GET_EXTRA_SUCCESS'
export const GET_EXTRA_ERROR= 'GET_EXTRA_ERROR'

export const GET_EXTRAS= 'GET_EXTRAS'
export const GET_EXTRAS_SUCCESS= 'GET_EXTRAS_SUCCESS'
export const GET_EXTRAS_ERROR='GET_EXTRAS_ERROR'

export const UNDELETE_EXTRA='UNDELETE_EXTRA'
export const UNDELETE_EXTRA_SUCCESS= 'UNDELETE_EXTRA_SUCCESS'
export const UNDELETE_EXTRA_ERROR='DELETE_EXTRA_ERROR'

export const UNDELETE_EXTRAS='UNDELETE_EXTRAS'
export const UNDELETE_EXTRAS_SUCCESS= 'UNDELETE_EXTRAS_SUCCESS'
export const UNDELETE_EXTRAS_ERROR= 'DELETE_EXTRAS_ERROR'

export const UPDATE_EXTRA='UPDATE_EXTRA'
export const UPDATE_EXTRA_SUCCESS= 'UPDATE_EXTRA_SUCCESS'
export const UPDATE_EXTRA_ERROR='UPDATE_EXTRA_ERROR'


export const AddExtra= (data) => ({
    type: ADD_EXTRA,
    payload: data
})

export const ChangeExtrasVisibility= (data) => ({
    type: CHANGE_EXTRAS_VISIBILITY,
    payload: data
})

export const DeleteExtra= (data) => ({
    type: DELETE_EXTRA,
    payload: data
})

export const DeleteExtras= (data) => ({
    type: DELETE_EXTRAS,
    payload: data
})

export const GetExtra= (data) => ({
    type: GET_EXTRA,
    payload: data
})

export const GetExtras= (data) => ({
    type: GET_EXTRAS,
    payload: data
})


export const UnDeleteExtra= (data) => ({
    type: UNDELETE_EXTRA,
    payload: data
})

export const UnDeleteExtras= (data) => ({
    type: UNDELETE_EXTRAS,
    payload: data
})

export const UpdateExtra= (data) => ({
    type: UPDATE_EXTRA,
    payload: data
})
